/**
 * クーポン一覧のクエリパラメータコントロール用middleware
 */
export default defineNuxtRouteMiddleware((to, from) => {
  if (!to.query.page) {
    return navigateTo({
      path: '/coupon',
      query: {
        page: 1,
      },
    });
  }
});
